export const GAME_STATS_MOCK = {
  status: 200,
  body: {
    status: 200,
    msg: 'OK',
    data: {
      nick: 'Player',
      activeDays: 1,
      bestScore: {
        value: 105,
        top: 93,
      },
      averageScore: {
        value: 105,
        top: 92,
      },
      winRate: {
        value: 0,
        top: 100,
      },
      completedRounds: {
        value: 1,
        top: 72,
      },
      wonRounds: {
        value: 0,
        top: 100,
      },
      drawnRounds: {
        value: 0,
        top: 100,
      },
      bestWinStreak: {
        value: 0,
        top: 100,
      },
      wonAmount: {
        value: 0,
        top: 100,
      },
      globalRank: 54,
    },
  },
};
